/*

Ashraf 11/28/2022 2805568664 added repo fields table
Ashraf 11/28/2022 2805568664 added mandatory column
Ashraf 11/28/2022 2805568664 mandatory text field display
Ashraf 12/01/2022 2805568664 removed disabling field
Ashraf 12/03/2022 2805568664 added asterik mark to mandatory field
dilip 12/5/2022 2805568664 Removed unnecessary console.log statements
Ashraf 12/12/2022 2805568664 fixed role based access in custom windows
Ashraf 12/14/2022 2805568664 fixed role based access
Ashraf 12/19/2022 2805568664 show field name on delete popup
suresh peddavoora 02/24/2023 2805568664 New UI changes
Akhila 03/16/2023 2805568664 Added unsaved changes popup while delete record
Sohel  05/05/2023 2805568664 Added Mandatory and View only Popup
Ravi 05/31/2023 2805568664 changed delete popup message
Sohel 10/10/2023 2805568664 Custom Window Delete payload Changes
Sohel 10/25/2023 2805568664 Fixed Mandatory and View Only Validation Toast issue
*/

import React, {useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {IconButton, Tooltip} from '@material-ui/core';
import PageLoader from '../../components/PageLoader';
import {useSelector} from 'react-redux';
import DeleteTableRecordPopup from '../../util/DeleteTableRecordPopup';

const FieldTable = ({
  recordFormatCode,
  selectedRows,
  setSelectedRows,
  values,
  handleChange,
  touched,
  errors,
  inputFieldValues,
  setInputFieldValues,
  setFieldValue,
  deletedRules,
  setDeletedRules,
  setrecordformatOpen,
  setFieldListApiData,
  fieldListApiData,
  fixedlength,
  isCopyRowData,
  handleDirty,
  setFieldTouched,
  isSubmitting,
}) => {
  const [loader, setLoader] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [userData, setUserData] = useState(null);

  const {customWindowData} = useSelector(({userDefinedWindow}) => userDefinedWindow);

  const reorderItems = (startIndex, endIndex) => {
    const arr = [...selectedRows];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setSelectedRows(arr);
  };

  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };

  const handleDelete = (rowData, key) => {
    const arr = [...selectedRows];
    arr.forEach((ele) => {
      delete ele.deleteState;
    });
    arr.splice(key, 1, {...arr[key], deleteState: true});
    // const newDeletedIds = [...deletedRules];
    // if (rowData?.reportFieldId) {
    //   newDeletedIds.push(rowData?.reportFieldId);
    // }
    setSelectedRows(arr);
    setUserData(rowData);
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleConfirmDelete = () => {
    setLoader(true);
    handleCloseDialog();
    setTimeout(() => {
      const arr = [...selectedRows].filter((r) => r.repositoryName + r.fieldName !== userData?.repositoryName + userData.fieldName);
      // const copyArr = [...fieldListApiData];
      // const updatedData = copyArr?.map((each) => {
      //   if (!filteredIds?.includes(each?.globalFieldId)) {
      //     return {
      //       ...each,
      //       tableData: { ...each?.tableData, checked: false },
      //     };
      //   } else {
      //     return {
      //       ...each,
      //       tableData: { ...each?.tableData, checked: true },
      //     };
      //   }
      // });
      const newDeletedIds = deletedRules?.length > 0 ? [...deletedRules] : [];
      if (userData?.fieldId) {
        newDeletedIds.push(userData?.fieldId);
      }
      setDeletedRules(newDeletedIds);
      setSelectedRows(arr);
      // setFieldListApiData(updatedData);
      setLoader(false);
    }, 1000);
    handleDirty(true);
  };

  // const handleCancel = (rowData, key) => {
  //   const arr = [...selectedRows];
  //   arr.forEach((ele) => {
  //     delete ele.deleteState;
  //   });
  //   setSelectedRows(arr);
  // };

  const {roleData} = useSelector(({role}) => role);
  // const disabledByRole = roleData?.window?.["Record Format"]?.["RF"]?.add;
  // const disableDelete = roleData?.window?.["Record Format"]?.["RF"]?.delete;

  // const roleAccess = roleData?.window?.["Record Format"]?.["RF"];
  // const viewOnly = !roleAccess?.edit && !roleAccess?.add && roleAccess?.read && !roleAccess?.delete;

  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Seq',
    },
    // {
    //   title: "Field Type",
    // },
    {
      title: 'Repository',
    },
    // {
    //   title: "Data Type",
    // },
    // {
    //   title: "Description",
    // },
    {
      title: 'Field Name',
    },
    // },
    {
      title: 'Field Label *',
    },
    {
      title: 'View Only',
    },
    {
      title: 'Mandatory',
    },
    {
      title: 'Multi Record',
    },
    // {
    //   title: "Date Format",
    // },
    // {
    //   title: "Print Subtotal",
    // },
  ];

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Field"
        value={`Are you sure you want to delete the ${userData?.fieldName?.replace(/ /g, '\u00a0')} Field?`}
        handleSubmit={handleConfirmDelete}
      />
      <div
        className={`mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields`}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead className="recFormat-header-container">
              <tr>
                {columns?.map(
                  ({title, hidden = false}) =>
                    !hidden && (
                      <th key={title} className="recFormat-header">
                        {title}
                      </th>
                    ),
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef} className="recFormat-body">
                  {selectedRows?.length > 0 ? (
                    selectedRows.map((rowData, key) => {
                      return (
                        <Draggable draggableId={`draggable-${key}`} index={key} key={key}>
                          {(provided) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <td className="recFormat-col recFormat-center">
                                <Tooltip title="Delete">
                                  <IconButton
                                    disabled={
                                      customWindowData?.windowId &&
                                      !isCopyRowData &&
                                      !roleData?.window?.['Custom Window Setup']?.CWS?.edit
                                    }
                                    onClick={(e) => {
                                      handleDelete(rowData, key);
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className="recFormat-col global-field-textfields">{key + 1}</td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData.repositoryName}
                              </td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData.fieldName}
                              </td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData?.fieldHeader({
                                  values,
                                  handleChange,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setFieldValue,
                                })}
                              </td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData?.viewOnlyTextField({
                                  values,
                                  handleChange,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setFieldValue,
                                  setFieldTouched,
                                  isSubmitting,
                                })}
                              </td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData?.mandatory({
                                  values,
                                  handleChange,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setFieldValue,
                                  setFieldTouched,
                                  isSubmitting,
                                })}
                              </td>
                              <td>{rowData.multiRecord === 'Y' ? 'Yes' : 'No'}</td>
                              {/* {values?.fixedLength !== "N" && fixedlength === "Y" && ( */}
                              {/* <td className="recFormat-col global-field-textfields">
                                {rowData.fieldLength({
                                  values,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setFieldValue,
                                })}
                              </td> */}
                              {/* )} */}
                              {/* <td className="recFormat-col global-field-textfields">
                                {rowData.format({
                                  values,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setFieldValue,
                                  dataType: rowData["dataType"],
                                  dropDownData,
                                  disabled: disabledDateFormat,
                                })}
                              </td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData.printTotals({
                                  values,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setFieldValue,
                                  disabled: printDisabled,
                                })}
                              </td> */}
                            </tr>
                          )}
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>
                        No records to display. To add fields to your custom window click the &quot;Map
                        Fields&quot; button in the top right of this section.
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                  {loader && <PageLoader />}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    </>
  );
};

export default FieldTable;
